import React from 'react';

interface PxtCmsLogoProps {
  /** Rendered width/height of the square mark in pixels. */
  size?: number;
}

/**
 * PXT CMS Admin Console brand mark (Concept 2): an amber rounded-tile monogram
 * with the "PXT" wordmark and a case underline. Inline SVG so it scales
 * crisply, works offline, and needs no external asset.
 */
const PxtCmsLogo = ({ size = 32 }: PxtCmsLogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    role="img"
    aria-label="PXT CMS Admin Console"
    focusable="false"
  >
    <rect x="5" y="5" width="30" height="30" rx="8" fill="#febd69" />
    <text
      x="20"
      y="21"
      textAnchor="middle"
      fontFamily="Amazon Ember, Arial, sans-serif"
      fontWeight="800"
      fontSize="12"
      fill="#16191f"
    >
      PXT
    </text>
    <rect x="12" y="25" width="16" height="3" rx="1.5" fill="#16191f" />
  </svg>
);

export default PxtCmsLogo;
